import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import "../../css/MainPage.css";

import Contact from "./Contact";

const ContactUS = () => {
  return (
    <div className="fd-main-wrapper page-padding">
      <Header />
      <main>
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default ContactUS;
